<template>
  <div class="tacenter">
    <div class="menu_title">
      <p class="title_english">{{englishText}}</p>
      <div class="title_chinese">{{positiveTitle}}</div>
    </div>
    <div class="menu_subheading">{{subheading}}</div>
  </div>
</template>

<script>
  export default {
      props:{
        englishText: {
          type: String,
          default: ''
        },
        positiveTitle: {
          type: String,
          default: ''
        },
        subheading: {
          type: String,
          default: ''
        },
      },
    }
</script>

<style scoped lang="less">
  .menu_title{
    position: relative;
    .title_english{
      color: #F2F2F2;
      opacity: 0.5;
    }
    .title_chinese{
      position: absolute;
      z-index: 2;
      left: 0;
      right: 0;
      text-align: center;
      font-weight: bold;
    }
  }
  .menu_subheading{margin-top: 10px;}
  @media screen and (max-width: 480px){
    .title_english{ font-size: 28px; }
    .title_chinese{font-size: 22px;top: 2px;}
    .menu_subheading{font-size: 14px;max-width: 300px;margin: 10px auto 0;}
  }
  @media screen and (min-width: 481px){
    .title_english{ font-size: 40px; }
    .title_chinese{font-size: 24px;top: 9px;}
    .menu_subheading{font-size: 18px;}
  }
</style>
